/* ============================================================
   ZAMARITH JEANS — EBOOK SCRIPTS
   ============================================================ */

(function () {
  'use strict';

  // ── PROGRESS BAR ──
  function initProgressBar() {
    var bar = document.querySelector('.ebook-progress-bar');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var doc = document.documentElement;
      var scrolled = doc.scrollTop || document.body.scrollTop;
      var total = doc.scrollHeight - doc.clientHeight;
      bar.style.width = ((scrolled / total) * 100) + '%';
    }, { passive: true });
  }

  // ── REVEAL ON SCROLL ──
  function initReveal() {
    var elements = document.querySelectorAll('.ebook-reveal');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, i * 60);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      elements.forEach(function (el) { observer.observe(el); });
    } else {
      // Fallback for older browsers
      elements.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // ── SMOOTH SCROLL FOR NAV LINKS ──
  function initSmoothScroll() {
    var links = document.querySelectorAll('.ebook-nav__links a[href^="#"]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ── ACTIVE NAV HIGHLIGHT ──
  function initActiveNav() {
    var sections = document.querySelectorAll('[data-ebook-section]');
    var navLinks = document.querySelectorAll('.ebook-nav__links a');
    if (!sections.length || !navLinks.length) return;

    window.addEventListener('scroll', function () {
      var scrollPos = window.scrollY + 100;
      sections.forEach(function (section) {
        var top = section.offsetTop;
        var bottom = top + section.offsetHeight;
        var id = section.getAttribute('id');
        if (scrollPos >= top && scrollPos < bottom) {
          navLinks.forEach(function (link) {
            link.style.opacity = link.getAttribute('href') === '#' + id ? '1' : '0.65';
          });
        }
      });
    }, { passive: true });
  }

  // ── INIT ──
  document.addEventListener('DOMContentLoaded', function () {
    initProgressBar();
    initReveal();
    initSmoothScroll();
    initActiveNav();
  });

})();
